import axios from "axios";
import {Base_URL} from "../url"

export const saveBalanceAdjustment = async (adjustmentData) => {
  try {
    const response = await axios.post(`${Base_URL}/BalanceAdjustmentAdvanceReq/BalanceAdjustment`, adjustmentData);
    console.log(response)
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving balance adjustment details!";
  }
};